import type { WidgetPreset } from "../types";
import manifest from "./stickers.json";

// The SVG files are the source of truth for the art; /work/design renders the
// same files, so the design sheet and the canvas cannot drift.
const markup = import.meta.glob<string>("./*.svg", {
  query: "?raw",
  import: "default",
  eager: true,
});

interface StickerManifestEntry {
  id: string;
  slug: string;
  label: string;
  meaning: string;
  family: NonNullable<WidgetPreset["family"]>;
  width: number;
  height: number;
}

export const STICKER_PRESETS: WidgetPreset[] = (
  manifest as StickerManifestEntry[]
).map((s) => ({
  id: s.id,
  label: s.label,
  meaning: s.meaning,
  family: s.family,
  html: markup[`./${s.slug}.svg`],
  defaultWidth: s.width,
  defaultHeight: s.height,
  resizable: { minWidth: s.width / 4, minHeight: s.height / 4 },
}));
